export default "__VITE_ASSET__CyeHCCX$__"